module.exports = __webpack_public_path__ + "static/img/xiaocx.4f1f1f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/imgs/xiaocx.jpg
// module id = 159u
// module chunks = 1